import React from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { FaWhatsapp, FaEnvelope, FaMapMarkerAlt, FaClock } from "react-icons/fa";
import { useMapLoaded } from "./MapLoader"; // Use the global MapProvider
import "./Contact.css";
import mapImage from "../assets/image.png"; // Replace with your image path
// Default container style
const containerStyle = {
  width: "100%",
  height: "400px",
};

// Default coordinates for Gorica Old Bridge, Gjirokastra, Albania
const defaultCenter = {
  lat: 40.0749,
  lng: 20.1386,
};

export default function Contact({ center = defaultCenter }) {
  // Get the loader state from MapProvider
  const isLoaded = useMapLoaded();
const openGoogleMaps = () => {
    window.open(
      "https://maps.app.goo.gl/YutACP223qFx45Cg9",
      "noopener,noreferrer"
    );
  };

  if (!isLoaded) return <p>Loading Map...</p>;

  return (
    <section id="contact" className="contact-section">
      <h2 className="contact-title">Contact</h2>

      <div className="contact-container">

        {/* Left: Contact Details */}
        <div className="contact-info">

          {/* Location - fully clickable */}
          <div
            className="contact-item clickable"
            onClick={() =>
              window.open(
                "https://www.google.com/maps/place/Gjirokaster+Free+Walking+Tour/@40.0749703,20.1386291,21z/data=!4m6!3m5!1s0x135b1d0065607ed5:0x14a9518536a3d1cc!8m2!3d40.0750383!4d20.1386368!16s%2Fg%2F11wq3v0rmt?entry=ttu&g_ep=EgoyMDI2MDIyNS4wIKXMDSoASAFQAw%3D%3D"
              )
            }
            style={{ cursor: "pointer" }}
          >
            <FaMapMarkerAlt className="contact-icon" />
            <div>
              <h4>Meeting Point</h4>
              <p>Gjirokaster Free Walking Tour</p>
              <p>Rruga Zejtareve (To the left of Rrapi Restaurant)</p>
            </div>
          </div>

          {/* WhatsApp - fully clickable */}
          <div
            className="contact-item clickable"
            onClick={() =>
              window.open("https://wa.me/355686328765", "_blank")
            }
            style={{ cursor: "pointer" }}
          >
            <FaWhatsapp className="contact-icon" />
            <div>
              <h4>Message us on WhatsApp</h4>
              <p>+355 68 632 8765</p>
              <p>Available 24 Hours</p>
            </div>
          </div>

          {/* Email - fully clickable */}
          <div
            className="contact-item clickable"
            onClick={() =>
              window.open("mailto:gjirokastratour@gmail.com")
            }
            style={{ cursor: "pointer" }}
          >
            <FaEnvelope className="contact-icon" />
            <div>
              <h4>Email</h4>
              <p>gjirokastratour@gmail.com</p>
              <p>We respond within 1 Hour</p>
            </div>
          </div>

          {/* Tour Schedule */}
          <div className="contact-item">
            <FaClock className="contact-icon" />
            <div>
              <h4>Tour Schedule</h4>
              <p>May to September: Daily at 10:00 AM, 1:30 PM  & 6:00 PM</p>
              <p>March, April, October: Daily 10:00 AM, 1:30 PM & 5:00 PM</p>
            </div>
          </div>

        </div>

        {/* Right: Google Map */}
 
    <div
      className="map-container"
      style={{
        display: "flex",
        justifyContent: "center",
        margin: "40px 0",
        padding: "20px",
 
        borderRadius: "16px",
 
      }}
    >
      <img
        src={mapImage}
        alt="Tour Location"
        onClick={openGoogleMaps}
        style={{
          width: "400px",   // fixed square size
          height: "400px",  // same as width
          borderRadius: "12px",
          cursor: "pointer",
          objectFit: "cover",  // crops image nicely
          boxShadow: "0 10px 20px rgba(0,0,0,0.15)",
          transition: "transform 0.3s, box-shadow 0.3s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.2)";
          e.currentTarget.style.boxShadow = "0 15px 25px rgba(0,0,0,0.2)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1.15)";
          e.currentTarget.style.boxShadow = "0 10px 20px rgba(0,0,0,0.15)";
        }}
      />
    </div>

        

      </div>
    </section>
  );
}
